import { type Option } from 'payload'

export enum PartnershipTier {
  Platinum = 'platinum',
  Gold = 'gold',
  Silver = 'silver',
  Bronze = 'bronze',
  Sponsored = 'sponsored',
}

const partnershipTierLabel = {
  [PartnershipTier.Platinum]: 'Platinum',
  [PartnershipTier.Gold]: 'Gold',
  [PartnershipTier.Silver]: 'Silver',
  [PartnershipTier.Bronze]: 'Bronze',
  [PartnershipTier.Sponsored]: 'Sponsored',
}

export const partnershipTierOptions: Option[] = [
  {
    value: PartnershipTier.Platinum,
    label: partnershipTierLabel[PartnershipTier.Platinum],
  },
  {
    value: PartnershipTier.Gold,
    label: partnershipTierLabel[PartnershipTier.Gold],
  },
  {
    value: PartnershipTier.Silver,
    label: partnershipTierLabel[PartnershipTier.Silver],
  },
  {
    value: PartnershipTier.Bronze,
    label: partnershipTierLabel[PartnershipTier.Bronze],
  },
  {
    value: PartnershipTier.Sponsored,
    label: partnershipTierLabel[PartnershipTier.Sponsored],
  },
] as const satisfies Option[]
